import { useState, useEffect } from "react";
import { ExternalLink, Play, Award } from "lucide-react";

const NOCES = {
  title: "Noces de paix à Kanou",
  author: "Justin Danwé",
  award: "Lauréat du Grand Prix Artistique MINDEF 2022 — Art littéraire « Roman »",
  description:
    "En pleins assauts contre Boko Haram, des cœurs battent la chamade. Kanou, petit village sahélien entre le Nord-Est du Nigéria et l'Extrême-Nord du Cameroun, connaît une grande précarité jusqu'au jour où un prélat français débarque. Un hymne à l'amour véritable vécu en temps de guerre, qui transcende les barrières religieuses et ethniques.",
  cover: "/covers/noces-de-paix.jpg",
  video: "/noces-de-paix-promo.mp4",
  amazon: "https://amzn.eu/d/0hRnaP1V",
};

export const FeaturedBook = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      data-testid="featured-book-noces"
      className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-[#1A1A1A] text-[#FAF9F6]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Video / Cover side */}
        <div className="lg:col-span-7 relative order-2 lg:order-1">
          {!playing ? (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              data-testid="play-video-button"
              className="relative w-full aspect-[3/4] md:aspect-video overflow-hidden group cursor-pointer block"
            >
              <img
                src={NOCES.cover}
                alt={NOCES.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-[#1A1A1A]/40 group-hover:bg-[#1A1A1A]/20 transition-colors flex items-center justify-center">
                <div className="bg-[#FAF9F6] text-[#1A1A1A] w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                  <Play size={28} className="ml-1.5" fill="currentColor" />
                </div>
              </div>
              <div className="absolute bottom-4 left-4 bg-[#9E4735] text-[#FAF9F6] text-[10px] tracking-[0.2em] uppercase font-body px-3 py-1.5">
                Vidéo promotionnelle
              </div>
            </button>
          ) : (
            <video
              src={NOCES.video}
              data-testid="featured-video"
              controls
              autoPlay
              className="w-full aspect-[3/4] md:aspect-video bg-[#1A1A1A]"
              poster={NOCES.cover}
            >
              Votre navigateur ne supporte pas la vidéo HTML5.
            </video>
          )}
        </div>

        {/* Text side */}
        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-6">
            <Award size={16} className="text-[#9E4735]" />
            <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body">
              Livre vedette
            </p>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] mb-4">
            {NOCES.title}
          </h2>
          <p className="text-base font-body text-[#D1CFC7] mb-6">
            par <em>{NOCES.author}</em>
          </p>
          <div className="border-l-2 border-[#9E4735] pl-4 mb-8">
            <p className="text-sm font-body text-[#9E4735] tracking-wide leading-snug">
              🏆 {NOCES.award}
            </p>
          </div>
          <p className="text-base md:text-lg text-[#D1CFC7] font-body leading-relaxed mb-10">
            {NOCES.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={NOCES.amazon}
              target="_blank"
              rel="noreferrer"
              data-testid="featured-amazon-button"
              className="inline-flex items-center justify-center gap-2 bg-[#FAF9F6] text-[#1A1A1A] hover:bg-[#9E4735] hover:text-[#FAF9F6] px-8 py-4 font-body tracking-wide transition-all"
            >
              Acheter sur Amazon <ExternalLink size={16} />
            </a>
            {!playing && (
              <button
                onClick={() => setPlaying(true)}
                data-testid="watch-video-button"
                className="inline-flex items-center justify-center gap-2 border border-[#FAF9F6] hover:bg-[#FAF9F6] hover:text-[#1A1A1A] px-8 py-4 font-body tracking-wide transition-all"
              >
                <Play size={16} /> Voir la vidéo
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
